import { useMutation } from '@tanstack/react-query';
import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import PersonRepository from '@/repositories/PersonRepository';
import { Button } from '@/ui/Button';

import { Props } from './types';

const CreateCandidPatientButton = ({ person }: Props) => {
  const { addMessage } = useContext(AppContext);
  const personRepository = PersonRepository();
  const { healthie_id, id: personId } = person;

  const { mutate, isPending } = useMutation({
    mutationFn: () => personRepository.createCandidPatient(personId),
    onSuccess: () => addMessage({ level: 'info', text: 'Creating Candid patient record...' }),
    onError: () => addMessage({ level: 'error', text: 'Could not start Candid patient creation' })
  });

  if (!healthie_id) {
    return null;
  }

  return (
    <Button
      color="secondary"
      isLoading={isPending}
      onClick={() => mutate()}
      className="px-3 pointer-coarse:h-11"
      size="md"
      variant="subtle">
      Create Candid Patient Record
    </Button>
  );
};

export default CreateCandidPatientButton;
